import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { TransmissionRunBatchItemSummaryEntity } from './transmission-run-batch-item-summary.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum TransmissionRunBatchItemSummaryActionTypes {
  LoadTransmissionRunBatchItemSummarys = '[TransmissionRunBatchItemSummary] Load TransmissionRunBatchItemSummarys',
  AddTransmissionRunBatchItemSummary = '[TransmissionRunBatchItemSummary] Add TransmissionRunBatchItemSummary',
  UpsertTransmissionRunBatchItemSummary = '[TransmissionRunBatchItemSummary] Upsert TransmissionRunBatchItemSummary',
  AddTransmissionRunBatchItemSummarys = '[TransmissionRunBatchItemSummary] Add TransmissionRunBatchItemSummarys',
  UpsertTransmissionRunBatchItemSummarys = '[TransmissionRunBatchItemSummary] Upsert TransmissionRunBatchItemSummarys',
  UpdateTransmissionRunBatchItemSummary = '[TransmissionRunBatchItemSummary] Update TransmissionRunBatchItemSummary',
  UpdateTransmissionRunBatchItemSummarys = '[TransmissionRunBatchItemSummary] Update TransmissionRunBatchItemSummarys',
  DeleteTransmissionRunBatchItemSummary = '[TransmissionRunBatchItemSummary] Delete TransmissionRunBatchItemSummary',
  DeleteTransmissionRunBatchItemSummarys = '[TransmissionRunBatchItemSummary] Delete TransmissionRunBatchItemSummarys',
  ClearTransmissionRunBatchItemSummarys = '[TransmissionRunBatchItemSummary] Clear TransmissionRunBatchItemSummarys',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadTransmissionRunBatchItemSummarys implements Action {
  public readonly type =
    TransmissionRunBatchItemSummaryActionTypes.LoadTransmissionRunBatchItemSummarys;

  constructor(
    public payload: { transmissionRunBatchItemSummarys: TransmissionRunBatchItemSummaryEntity[] },
  ) {}
}

export class AddTransmissionRunBatchItemSummary implements Action {
  public readonly type =
    TransmissionRunBatchItemSummaryActionTypes.AddTransmissionRunBatchItemSummary;

  constructor(
    public payload: { transmissionRunBatchItemSummary: TransmissionRunBatchItemSummaryEntity },
  ) {}
}

export class UpsertTransmissionRunBatchItemSummary implements Action {
  public readonly type =
    TransmissionRunBatchItemSummaryActionTypes.UpsertTransmissionRunBatchItemSummary;

  constructor(
    public payload: { transmissionRunBatchItemSummary: TransmissionRunBatchItemSummaryEntity },
  ) {}
}

export class AddTransmissionRunBatchItemSummarys implements Action {
  public readonly type =
    TransmissionRunBatchItemSummaryActionTypes.AddTransmissionRunBatchItemSummarys;

  constructor(
    public payload: { transmissionRunBatchItemSummarys: TransmissionRunBatchItemSummaryEntity[] },
  ) {}
}

export class UpsertTransmissionRunBatchItemSummarys implements Action {
  public readonly type =
    TransmissionRunBatchItemSummaryActionTypes.UpsertTransmissionRunBatchItemSummarys;

  constructor(
    public payload: { transmissionRunBatchItemSummarys: TransmissionRunBatchItemSummaryEntity[] },
  ) {}
}

export class UpdateTransmissionRunBatchItemSummary implements Action {
  public readonly type =
    TransmissionRunBatchItemSummaryActionTypes.UpdateTransmissionRunBatchItemSummary;

  constructor(
    public payload: {
      transmissionRunBatchItemSummary: Update<TransmissionRunBatchItemSummaryEntity>;
    },
  ) {}
}

export class UpdateTransmissionRunBatchItemSummarys implements Action {
  public readonly type =
    TransmissionRunBatchItemSummaryActionTypes.UpdateTransmissionRunBatchItemSummarys;

  constructor(
    public payload: {
      transmissionRunBatchItemSummarys: Update<TransmissionRunBatchItemSummaryEntity>[];
    },
  ) {}
}

export class DeleteTransmissionRunBatchItemSummary implements Action {
  public readonly type =
    TransmissionRunBatchItemSummaryActionTypes.DeleteTransmissionRunBatchItemSummary;

  constructor(public payload: { id: string }) {}
}

export class DeleteTransmissionRunBatchItemSummarys implements Action {
  public readonly type =
    TransmissionRunBatchItemSummaryActionTypes.DeleteTransmissionRunBatchItemSummarys;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearTransmissionRunBatchItemSummarys implements Action {
  public readonly type =
    TransmissionRunBatchItemSummaryActionTypes.ClearTransmissionRunBatchItemSummarys;
}

export type TransmissionRunBatchItemSummaryActions =
  | LoadTransmissionRunBatchItemSummarys
  | AddTransmissionRunBatchItemSummary
  | UpsertTransmissionRunBatchItemSummary
  | AddTransmissionRunBatchItemSummarys
  | UpsertTransmissionRunBatchItemSummarys
  | UpdateTransmissionRunBatchItemSummary
  | UpdateTransmissionRunBatchItemSummarys
  | DeleteTransmissionRunBatchItemSummary
  | DeleteTransmissionRunBatchItemSummarys
  | ClearTransmissionRunBatchItemSummarys;
